module.exports = require("@swa-ui/application/src/ContextVisualizer/ContextVisualizer.module.scss");